import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import {
  getRecommendBanner,
  getRecommendGroup,
  getRecommendReco,
  getRecommendWeekHot,
} from '../../actions/recommend';
import CardIndex from '../../card/CardIndex/CardIndex';
import styles from './RecoWork.module.less';
import Loading from '../../components/Loading/Loading';

const selectBanners = createSelector(
  state => state.recommend,
  recommend => recommend.banners,
);
const selectWeekHots = createSelector(
  state => state.recommend,
  recommend => recommend.weekHots,
);
const selectRecommends = createSelector(
  state => state.recommend,
  recommend => recommend.recommends,
);
const selectGroups = createSelector(
  state => state.recommend,
  recommend => recommend.groups,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();

  const bannersData = useSelector(selectBanners);
  const weekHotsData = useSelector(selectWeekHots);
  const recommendsData = useSelector(selectRecommends);
  const groupsData = useSelector(selectGroups);
  const logInfoData = useSelector(selectLogInfo);

  const [getBannerKey, setGetBannerKey] = useState(null);
  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Work`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Work',
        label: '',
        param2: {
          source: 'Work',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Work',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  /**
   * 因为广告接入，计算统计接口请求，和展示次数矛盾。
   * 所以改为：每次展示banner，都重新请求一次数据
   */
  useEffect(() => {
    const getBannerKeyNum = +new Date();
    setGetBannerKey(getBannerKeyNum);
    dispatch(getRecommendBanner({ getBannerKey: getBannerKeyNum, pageType: 'work' }));
  }, [dispatch]);

  useEffect(() => {
    if (!weekHotsData || !weekHotsData.dataList || weekHotsData.pageType !== 'work') {
      dispatch(getRecommendWeekHot({ pageType: 'work' }));
    }
  }, [dispatch, weekHotsData]);

  useEffect(() => {
    if (
      !recommendsData ||
      !recommendsData.dataList ||
      !recommendsData.dataList.length ||
      recommendsData.pageType !== 'work'
    ) {
      dispatch(getRecommendReco({ pageType: 'work' }));
    }
  }, [dispatch, recommendsData]);

  useEffect(() => {
    if (
      !groupsData ||
      !groupsData.dataList ||
      groupsData.dataList === undefined ||
      groupsData.pageType !== 'work'
    ) {
      dispatch(getRecommendGroup({ pageType: 'work' }));
    }
  }, [dispatch, groupsData]);

  if (
    !(
      bannersData &&
      bannersData.pageType === 'work' &&
      bannersData.dataList &&
      bannersData.dataList.length > 0 &&
      getBannerKey &&
      bannersData.getBannerKey === getBannerKey &&
      weekHotsData &&
      weekHotsData.pageType === 'work' &&
      weekHotsData.dataList &&
      weekHotsData.dataList.length > 0 &&
      recommendsData &&
      recommendsData.pageType === 'work' &&
      recommendsData.dataList &&
      recommendsData.dataList.length > 0 &&
      groupsData &&
        groupsData.pageType === 'work' &&
        groupsData.dataList &&
        groupsData.dataList.length > 0
    )
  ) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.recommend}>
      {/* banner and 本周最热 */}
      {bannersData &&
        bannersData.pageType === 'work' &&
        bannersData.dataList &&
        bannersData.dataList.length > 0 &&
        getBannerKey &&
        bannersData.getBannerKey === getBannerKey &&
        weekHotsData &&
        weekHotsData.pageType === 'work' &&
        weekHotsData.dataList &&
        weekHotsData.dataList.length > 0 && (
          <div className={styles.recommend_banner_weekhot}>
            <CardIndex data={bannersData} logInfo={{ tag: 'Work' }} />
            <CardIndex data={weekHotsData} logInfo={{ tag: 'Work' }} />
          </div>
        )}
      {/* 精品推荐 */}
      {recommendsData &&
        recommendsData.pageType === 'work' &&
        recommendsData.dataList &&
        recommendsData.dataList.length > 0 && (
          <CardIndex data={recommendsData} logInfo={{ tag: 'Work' }} />
        )}
      {/* group */}
      {groupsData &&
        groupsData.pageType === 'work' &&
        groupsData.dataList &&
        groupsData.dataList.length > 0 &&
        groupsData.dataList.map((item, i) => (
          <CardIndex data={{ ...item }} key={i} logInfo={{ tag: 'Work' }} />
        ))}
    </div>
  );
});
